import { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import WhatsApp from "../assets/whatsapp.png";

import aboutHero from "../assets/wildlife-safaris.jpg";

function SafariBook() {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        nationality: "",
        safariPark: "",
        safariTime: "",
        jeepType: "",
        adults: "",
        children: "",
        date: "",
        pickup: "",
        message: ""
    });

    const handleReset = () => {
        setFormData({
            name: "",
            phone: "",
            email: "",
            nationality: "",
            safariPark: "",
            safariTime: "",
            jeepType: "",
            adults: "",
            children: "",
            date: "",
            pickup: "",
            message: ""
        });
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const whatsappNumber = "94750800887";

        const text = `
        🦁 Safari Booking Inquiry - Sri Lanka

        Name: ${formData.name}
        Phone: ${formData.phone}
        Email: ${formData.email}
        Nationality: ${formData.nationality}

        Safari Park: ${formData.safariPark}
        Safari Time: ${formData.safariTime}
        Jeep Type: ${formData.jeepType}

        Adults: ${formData.adults}
        Children: ${formData.children}

        Date: ${formData.date}
        Pickup Location: ${formData.pickup}

        Message: ${formData.message}
                `;

        const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;
        window.open(url, "_blank");
    };

    return (

        <div className="w-full overflow-hidden">

            {/* ================= HERO ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${aboutHero})` }}
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white">
                    <h1
                        data-aos="fade-up"
                        className="text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Safari Book
                    </h1>

                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mt-4 sm:mt-6 max-w-full sm:max-w-2xl md:max-w-3xl text-sm sm:text-base md:text-lg"
                    >
                        Book Your Safari Now
                    </p>
                </div>
            </section>

            <section className="bg-gray-100 py-12 px-4">
                <div className="max-w-4xl mx-auto bg-white p-8 rounded-xl shadow-xl">

                    <h2 className="text-2xl font-bold text-center mb-6">
                        Safari Booking
                    </h2>

                    <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        {/* Name */}
                        <input
                            type="text"
                            name="name"
                            required
                            placeholder="Your Name"
                            value={formData.name}
                            onChange={handleChange}
                            className="p-3 rounded-full border"
                        />

                        {/* Phone */}
                        <input
                            type="tel"
                            name="phone"
                            placeholder="Phone (+94...)"
                            value={formData.phone}
                            onChange={handleChange}
                            className="p-3 rounded-full border"
                        />

                        {/* Email */}
                        <input
                            type="email"
                            name="email"
                            required
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleChange}
                            className="p-3 rounded-full border md:col-span-2"
                        />

                        {/* Nationality */}
                        <select
                            name="nationality"
                            required
                            value={formData.nationality}
                            onChange={handleChange}
                            className="p-3 rounded-full border"
                        >
                            <option value="">Nationality</option>
                            <option>Local</option>
                            <option>Foreign</option>
                        </select>

                        {/* Safari Park */}
                        <select
                            name="safariPark"
                            required
                            value={formData.safariPark}
                            onChange={handleChange}
                            className="p-3 rounded-full border"
                        >
                            <option value="">Select Safari Park</option>
                            <option>Yala National Park</option>
                            <option>Udawalawe National Park</option>
                            <option>Wilpattu National Park</option>
                            <option>Minneriya National Park</option>
                            <option>Kaudulla National Park</option>
                            <option>Bundala National Park</option>
                        </select>

                        {/* Safari Time */}
                        <select
                            name="safariTime"
                            required
                            value={formData.safariTime}
                            onChange={handleChange}
                            className="p-3 rounded-full border"
                        >
                            <option value="">Safari Time</option>
                            <option>Morning Safari</option>
                            <option>Evening Safari</option>
                            <option>Full Day Safari</option>
                        </select>

                        {/* Jeep Type */}
                        <select
                            name="jeepType"
                            required
                            value={formData.jeepType}
                            onChange={handleChange}
                            className="p-3 rounded-full border"
                        >
                            <option value="">Jeep Type</option>
                            <option>Private Jeep</option>
                            <option>Sharing Jeep</option>
                            <option>Luxury Jeep</option>
                        </select>

                        {/* Adults */}
                        <input
                            type="number"
                            name="adults"
                            required
                            placeholder="Adults"
                            value={formData.adults}
                            onChange={handleChange}
                            className="p-3 rounded-full border"
                        />

                        {/* Children */}
                        <input
                            type="number"
                            name="children"
                            placeholder="Children"
                            value={formData.children}
                            onChange={handleChange}
                            className="p-3 rounded-full border"
                        />

                        {/* Date */}
                        <input
                            type="date"
                            name="date"
                            required
                            value={formData.date}
                            onChange={handleChange}
                            className="p-3 rounded-full border"
                        />

                        {/* Pickup */}
                        <input
                            type="text"
                            name="pickup"
                            required
                            placeholder="Pickup Location (Hotel / City)"
                            value={formData.pickup}
                            onChange={handleChange}
                            className="p-3 rounded-full border"
                        />

                        {/* Message */}
                        <textarea
                            name="message"
                            placeholder="Special requests..."
                            value={formData.message}
                            onChange={handleChange}
                            className="p-4 rounded-xl border md:col-span-2"
                        />

                        {/* Submit */}
                        <div className="md:col-span-2 flex flex-col sm:flex-row gap-4 justify-center mt-4">

                            {/* Submit */}
                            <button
                                type="submit"
                                className="bg-green-600 text-white px-8 py-3 rounded-full hover:bg-green-700 transition"
                            >
                                Book Safari via WhatsApp
                            </button>

                            {/* Cancel */}
                            <button
                                type="button"
                                onClick={handleReset}
                                className="bg-gray-500 text-white px-8 py-3 rounded-full hover:bg-gray-700 transition"
                            >
                                Cancel
                            </button>

                        </div>

                    </form>
                </div>
            </section>

        </div>
    );
}

export default SafariBook;